import { render, staticRenderFns } from "./ChoosePerson.vue?vue&type=template&id=fa568d34&scoped=true"
import script from "./ChoosePerson.vue?vue&type=script&lang=js"
export * from "./ChoosePerson.vue?vue&type=script&lang=js"
import style0 from "./ChoosePerson.vue?vue&type=style&index=0&id=fa568d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa568d34",
  null
  
)

export default component.exports